module.exports = __webpack_public_path__ + "static/img/role.d4bcddb.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/mx/role.png
// module id = Dsup
// module chunks = 7